'use client';
import { useEffect } from 'react';
import { track } from '../../lib/util/tracking';

type Props = { nodeID: number };

/**
 * Description: answer page track visit.
 */
const TrackVisit = ({ nodeID }: Props) => {
  // Track answer pages views
  useEffect(() => {
    void track(
      `answer_page_visited_${nodeID}`,
      {
        nodeID,
      },
      ['internal'],
      { frequency: 'day' },
    );
  }, []);

  return null;
};

export default TrackVisit;
